<template>
  <AddEditSubFolder></AddEditSubFolder>
</template>

<script>
import AddEditSubFolder from "@/layouts/components/masters/sub-folders/addedit-sub_folder.vue";
export default {
  components: {
    AddEditSubFolder,
  },
};
</script>
